import React from "react";
import { useTranslation } from "react-i18next";
import { sideMenu } from "../../../../config/sideMenu";
import { NavLink } from "react-router-dom";
import environment from "../../../../environment/environment";

export const FooterCenter: React.FC = () => {
  const { t } = useTranslation();
  const phoneNumber = environment.phoneNumber;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const phoneNumberClean = phoneNumber.replace(/\s+/g, "");

  return (
    <section className="flex flex-col items-start text-black">
      {/* Contact Section */}
      <div className="mb-8 flex gap-4 items-start">
        <div className="text-gray-500 text-lg mb-1 min-w-[135px] font-title itelic font-bold">
          {t("footer.contact", "Contact")}
        </div>
        <div className="text-sm text-bold">
          <a href={`tel:${phoneNumber}`} className="block font-bold text-base">
            {phoneNumber}
          </a>
        </div>
      </div>

      {/* Info Section */}
      <div className="mb-12 flex gap-4 items-start">
        <div className="text-gray-500 text-lg mb-1 min-w-[135px] font-title italic">
          {t("footer.pages", "Pages")}
        </div>
        <div className="text-sm">
          {sideMenu.map((item, index) => (
            <NavLink
              key={item.title}
              to={item.path}
              className={({ isActive }) =>
                `block text-base ${index > 0 ? "mt-1" : ""} ${isActive ? "text-primary font-medium" : "text-black hover:text-primary"}`
              }
            >
              {item.title}
            </NavLink>
          ))}
        </div>
      </div>
    </section>
  );
};
